// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__XjZza","carousel":"carousel_carousel__c6h3K","item":"carousel_item__rNoNU","btn":"carousel_btn__qn_OM","disabledBtn":"carousel_disabledBtn__3_i7P"};